import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_icon = _resolveComponent("ui-icon")!
  const _component_ui_input = _resolveComponent("ui-input")!

  return ($props.raw.type === 'dataset')
    ? (_openBlock(), _createBlock(_component_ui_input, {
        key: 0,
        type: "color",
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
        width: "var(--icon-width)",
        modelValue: $props.raw.origin.color,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = v => $setup.emit('updateColor', v)),
        height: "100%"
      }, {
        replace: _withCtx(() => [
          _createVNode(_component_ui_icon, {
            type: $props.icon,
            color: $props.raw.origin.color
          }, null, 8 /* PROPS */, ["type", "color"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue"]))
    : (_openBlock(), _createBlock(_component_ui_icon, {
        key: 1,
        style: {"width":"var(--icon-width)"},
        type: $props.icon
      }, null, 8 /* PROPS */, ["type"]))
}